import React from 'react';

const RadioCardGroup = ({ name, options, value, onChange }) => (
  <div className="ef-radio-cards" role="radiogroup">
    {options.map((option) => {
      const selected = value === option.value;
      return (
        <button
          key={option.value}
          type="button"
          className={['ef-radio-card', selected ? 'ef-radio-card--selected' : '']
            .filter(Boolean)
            .join(' ')}
          onClick={() => onChange(option.value)}
          aria-checked={selected}
          role="radio"
        >
          <span className="ef-radio-card__dot" />
          <span>
            <span className="ef-radio-card__title">{option.label}</span>
            {option.subtitle && (
              <span className="ef-radio-card__subtitle">{option.subtitle}</span>
            )}
          </span>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selected}
            onChange={() => onChange(option.value)}
            tabIndex={-1}
            aria-hidden="true"
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
          />
        </button>
      );
    })}
  </div>
);

export default RadioCardGroup;
